// features/alert/alertSlice.js
import { createSlice } from "@reduxjs/toolkit";

const alertSlice = createSlice({
  name: "alert",
  initialState: {
    open: false,
    message: "",
    severity: "success", // 'error' or 'info' or 'warning'
  },
  reducers: {
    setAlert: (state, action) => {
      state.open = true;
      state.message = action.payload.message;
      state.severity = action.payload.severity || "success"; // Default is success
    },
    clearAlert: (state) => {
      state.open = false;
      state.message = "";
      state.severity = "success";
    },
  },
});

export const { setAlert, clearAlert } = alertSlice.actions;

export default alertSlice.reducer;
